/**
 * 表格默认的属性
 */
export default {
  border: true // 显示边框

};